import {createSlice} from '@reduxjs/toolkit'
import {clearTokenExpiry} from '@shared/utils/tokenExpiry'

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: localStorage.getItem('token'),
    isLoggedIn: !!localStorage.getItem('token'),
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload
      state.isLoggedIn = true
      localStorage.setItem('token', action.payload)
    },
    logoutUserAction: (state) => {
      state.token = null
      state.isLoggedIn = false
      localStorage.removeItem('token')
      clearTokenExpiry()
    },
  },
})

export const {logoutUserAction} = authSlice.actions
export default authSlice.reducer
